/**
 * What the hints around the app copy for a person to paste into their AI tool
 * (spec 248). Plain words rather than a slash command: Claude Code and Copilot
 * name a server's prompts differently and Codex and claude.ai have none, but
 * every one of them reads an ask. Each names its subject by title and id, so
 * the tool finds the exact one, and ends as the server's own prompts do: change
 * nothing until the person says so.
 */

interface Named {
  id: string;
  title: string;
}

/** The task menu's ask: where this task stands and what is next. */
export function pickUpTaskAsk(task: Named): string {
  return `Pick up the task "${task.title}" (id ${task.id}) in AI-Powered SDLC: tell me what it is for, where it stands and what comes next. Change nothing until I say so.`;
}

/** A failed run's ask: that run, not the latest, since the card may be older. */
export function whyRunFailedAsk(task: Named, runId: string): string {
  return `Run ${runId} of the task "${task.title}" (id ${task.id}) in AI-Powered SDLC failed. Read what it did and tell me where it went wrong, the likely cause and what to change. Change nothing and rerun nothing until I say so.`;
}

/**
 * The New workflow dialog's ask. Ends on "The goal: " for the person to finish
 * in their tool; the workspace is named when its name is known.
 */
export function draftWorkflowAsk(workspace: {
  id: string;
  name?: string;
}): string {
  const where =
    workspace.name === undefined
      ? `the AI-Powered SDLC workspace with id ${workspace.id}`
      : `the AI-Powered SDLC workspace "${workspace.name}" (id ${workspace.id})`;
  return `Help me write a new workflow in ${where}. Look at one or two of its workflows for the shape and propose the steps in plain words first. Import nothing until I say so. The goal: `;
}
